export default __webpack_public_path__ + "static/media/pdf-icon.06602c65.svg";